import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarBackgroundEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction } = useCrudActions();

    const model = reactive({
        id: route.params?.id,
        name: null,
        price: 0,
        isPublished: false,
        isDefault: false,
        isNew: false,
        isSpecial: false,
        image: null,
        imageFile: null,
        imageStatus: null,
        canEditDefault: true
    });

    const validations = {
        name: { required },
        price: { required, numeric }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        request: () => avatarService.background.get(route.params.id),
        onSuccess: ({ data }) => {
            Object.assign(model, data);
            model.canEditDefault = !model.isDefault;
        },
        onError: () => router.push({ name: ROUTE_NAME_AVATAR.BACKGROUND.INDEX })
    });

    const update = executeAction({
        validator: v$,
        request: () =>
            avatarService.background.update(
                model.id,
                model.name,
                model.price,
                model.isPublished,
                model.isDefault,
                model.isNew,
                model.isSpecial,
                model.imageFile
            ),
        onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.BACKGROUND.INDEX }),
        successMessage: 'Update successfully'
    });

    return { model, v$, fetch, update };
}
